import { Component, Input, ViewChild } from "@angular/core";
import { CBP3461 } from "../../../../objects/documents/CBP3461";
import { ValidationPatterns } from "../../../../common/helpers/ValidationPatterns";
import { NgForm } from "@angular/forms";

@Component({
    selector: 'header-parties-3461',
    templateUrl: "header-parties-3461.component.html",
    moduleId: module.id.toString()
})
export class HeaderParties3461Component {
    @Input()
    public document: CBP3461;

    @ViewChild("headerPartiesForm")
    public headerPartiesForm: NgForm;

    public numberPatternHelper = ValidationPatterns;

    public isFormValid(): boolean {
        return this.headerPartiesForm.valid;
    }

    public submitFormAndValidity(): boolean {
        this.headerPartiesForm.onSubmit(null);

        return this.isFormValid();
    }

}


// WEBPACK FOOTER //
// ./app/components/export-documents/cbp-3461/document-blocks/header-parties-3461.component.ts